import SSpyMobileHandler from './SSpyMobileHandler'

export default SSpyMobileHandler
